import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Navbar from './Navbar';
import ContentItem from './ContentItem';
import dummyData from '../dummyData';
import './SearchResultsPage.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResultsPage() {
  const queryParams = useQuery();
  const searchQuery = queryParams.get('query')?.toLowerCase() || '';
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    if (searchQuery) {
      const allItems = Object.entries(dummyData).flatMap(([category, items]) => 
        items.map(item => ({ ...item, category }))
      );
      
      const filteredResults = allItems.filter(item => 
        item.title.toLowerCase().includes(searchQuery) ||
        item.brief.toLowerCase().includes(searchQuery) ||
        (item.details && item.details.toLowerCase().includes(searchQuery)) ||
        (item.tags && item.tags.some(tag => tag.toLowerCase().includes(searchQuery)))
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery]);

  return (
    <div>
      <Navbar />
      <div className="search-results-page">
        <h1>搜索结果： "{searchQuery || ''}"</h1>
        {searchQuery && searchResults.length > 0 && (
          <p className="results-count">找到了 {searchResults.length} 条相关内容。</p>
        )}
        <div className="results-list">
          {searchQuery ? (
            searchResults.length > 0 ? (
              searchResults.map(item => (
                <ContentItem key={`${item.category}-${item.id}`} item={item} />
              ))
            ) : (
              <p>抱歉，没有找到与 "{searchQuery}" 相关的内容。请尝试其他关键词。</p>
            )
          ) : (
            <p>请输入关键词进行搜索。</p>
          )}
        </div>
        <Link to="/" className="back-link">返回首页</Link>
      </div>
    </div>
  );
}

export default SearchResultsPage;
